import { Component, OnInit, Output, EventEmitter   } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgIf } from '@angular/common';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

//Services
import { AlterarSenhaService } from './alterar-senha.service';

//Components
import { AlterarSenhaVO } from '../base/vo/alterar-senha';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.css']
})
export class AlterarSenhaComponent implements OnInit {

	alterarSenhaVO: AlterarSenhaVO;
	loading: boolean;
	listErrors: any;
	
	@Output() alterarSenhaSucesso = new EventEmitter<boolean>();

	constructor(private alterarSenhaService: AlterarSenhaService, private messageService: MessageService) { }
	
	ngOnInit() {
		this.alterarSenhaVO = new AlterarSenhaVO();
		this.loading = false;
		this.listErrors = undefined;
	}
	
	alterarSenha() {
		this.loading = true;
		this.alterarSenhaService.alterarSenha(this.alterarSenhaVO).subscribe(
        	data => {
        		this.loading = false;
        		this.listErrors = undefined;
        		this.messageService.add({severity:'success', summary:'Alterar Senha', detail: 'A senha foi alterada com sucesso!'});
        		this.alterarSenhaSucesso.emit(true);
        	},
	        erro => {
	        	this.loading = false;
	        	this.listErrors = erro.error.errors;
	        	this.alterarSenhaSucesso.emit(false);
	        }
    	);
	}
	
	getMsgErro(campo) {
		if(this.listErrors && campo) {
			for (let index = 0; index < this.listErrors.length; index++) {
		    	if(this.listErrors[index].field == campo ) {
		    		return this.listErrors[index].message;
		    	}
		    }
		}
		
		return null;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/alterar-senha/alterar-senha.component.ts